import { addSlashToEndOfUrl } from 'src/shared/helpers/add-slash-to-end-of-url/add-slash-to-end-of-url';

export const resolveDuplicateSlashUrl = (url: string): string => {
    const addedSlashToEnd = addSlashToEndOfUrl(url);

    return addedSlashToEnd.replace(/([^:]\/)\/+/g, '$1');
};
